import {NewLiveCasinoConfiguration} from "../../../../services/configurations/config-data-sections/arenas.configuration";
import {observer} from "mobx-react";
import {IStickyHandler} from "../../../sticky-handler/sticky-handler.interface";
import React from "react";
import {LiveCasinoArenaNavbar} from "../../../arena-host/new-live-casino-arena/live-casino-arena-navbar/live-casino-arena-navbar.component";
import {LiveCasinoArenaGrid} from "../../../arena-host/new-live-casino-arena/live-casino-arena-grid/live-casino-arena-grid.component";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {MiniOrbitLiveCasinoFilterButton} from "./parts/mini-orbit-live-casino-filter-button/mini-orbit-live-casino-filter-button.component";
import {LIVE_CASINO_PAGE_WRAPPER} from "../../../../themes/css-global-classes";
import {FreeToPlayAnimatedIconComponent} from "../../../free-to-play-animated-icon/free-to-play-animated-icon.component";

export interface MiniOrbitNewLiveCasinoArenaComponentProps {
    configs: NewLiveCasinoConfiguration;
    arenaName: string;
}

const SEO_CATEGORY = 'LIVE_CASINO_NEW';

export const MiniOrbitNewLiveCasinoArenaComponent = observer(
    class MiniOrbitNewLiveCasinoArenaComponent extends OrbitComponent<MiniOrbitNewLiveCasinoArenaComponentProps> {

        private _stickyHandler: IStickyHandler;

        private get stickyHandler(): IStickyHandler {
            if (!this._stickyHandler) {
                this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
            }
            return this._stickyHandler;
        }

        render() {
            return (
                <div className={LIVE_CASINO_PAGE_WRAPPER}>
                    {
                        this.services.liveTableFeeds.isNavbarVisible && <LiveCasinoArenaNavbar
                            configs={this.services.liveTableFeeds.liveArenaTabsConfiguration}
                            stickyHandler={this.stickyHandler}
                            FilterButtonComponent={MiniOrbitLiveCasinoFilterButton}
                        />
                    }
                    <LiveCasinoArenaGrid
                        seoCategory={SEO_CATEGORY}
                        useAISortedList={this.props.configs.useAISortedList} />
                    <FreeToPlayAnimatedIconComponent />
                </div>
            );
        }
    }
);
